import { useLanguageMixin } from "/@/mixin/languageHook.js";
import { useSelect } from "/@/store/select.js";
import router from "/@/router/index.js";
export const useAiInteractive = () => {
  const { buildCurrentLanguageUrl } = useLanguageMixin();
  const searchPump = (data) => {
    router.push({
      path: buildCurrentLanguageUrl("/EBook/searchProduct"),
      query: {
        keyWords: data.args.KeyWord,
      },
    });
  };

  const selectPump = (data) => {
    const selectStore = useSelect();
    const { CbResult } = data;
    let CatlogIDs = [];
    let SeriesIDs = CbResult.SeriesID;
    let selectInfo = {
      JieZhi: {
        ID: "1",
        Name: "清水",
        CalcDensity: 1000,
        CalcViscosity: 1,
        Temperature: "20.0",
        V_C: 100,
        MiDuUnit: 0,
        NianDuUnit: 0,
        IsCustom: false,
      },
      FilterInfo: {
        DriveType: "0",
        KeyWord: "",
        MotorPoleNum: "null",
        DieselSpeed: "",
        MotorFrequence: 50,
        FirePumpType: "0",
        Temperature: "20.0",
        MinEta: "",
        MotorStandard: 1,
        MotorPower: "",
        NPSHa: "",
        SeriesSelectMethod: 1,
        SeriesID: SeriesIDs.join(","),
        CatalogID: CatlogIDs.join(","),
      },
      DesignInfo: {
        UnitQ: 1,
        UnitH: 0,
        DpQ: CbResult.Flow,
        DpH: CbResult.Head,
        IsAllowCut: true,
        IsAllowFrequence: true,
        ToleranceStand: 1,
        PointTolerance: {
          ToleranceGrade: 13,
          RatioMinQ: "0.92",
          RatioMaxQ: "1.08",
          RatioMinH: "0.95",
          RatioMaxH: "1.05",
        },
        IsVisCorrect: false,
      },
    };
    selectStore.setByParas({
      selectParas: selectInfo,
    });
    let path = buildCurrentLanguageUrl("/Select/PumpList/Index");
    router.push({
      path: path,
      query: {
        d: new Date().getTime(),
      },
    });

    openChartWindow();
  };

  
  const cbPageJumpByType = (data) => {
    const { type, value } = data;
    if (type == "page_jump") {
      const routerPath = buildCurrentLanguageUrl(value);
      const origin = window.location.origin;
      const pathname = window.location.pathname;
      const fullUrl = origin + pathname + "#" + routerPath;
      window.open(fullUrl, "_blank");
    }
  };

  // 打开窗口
  const openChartWindow = () => {
    const ai_chart_frameElement = document.getElementById("AIChartWindow");
    if (ai_chart_frameElement) {
      ai_chart_frameElement.style.display = "block";
      sessionStorage.setItem('m_IsCloseChartWindow', JSON.stringify(true));
    }
  };

  // 关闭窗口
  const closeChartWindow = () => {
    const ai_chart_frameElement = document.getElementById("AIChartWindow");
    if (ai_chart_frameElement) {
      ai_chart_frameElement.style.display = "none";
      sessionStorage.setItem('m_IsCloseChartWindow', JSON.stringify(false));
    }
  };


  const aiInteractive = (data) => {
    const { CbPage } = data;
    const typeMap = {
      FilterByKeyWrd: searchPump,
      PumpSelectList: selectPump,
    };
    typeMap[CbPage](data);
  };

  return {
    aiInteractive,
    closeChartWindow,
    openChartWindow,
    cbPageJumpByType,
  };
};
